import { LoadTokeetAIChargesComplete } from './ai-charge.actions'
import { adapter, initialState, State } from './ai-charge.state'
import * as R from 'ramda'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(LoadTokeetAIChargesComplete, (state, { items }) => adapter.setAll(items, R.merge(state, { isLoaded: true })))
)

export function billingReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
